import { Directive, HostBinding, HostListener, Input } from "@angular/core";
import { MatTooltip } from "@angular/material/tooltip";

// Ícone de ajuda ("i") com `matTooltip`. No toque, o tooltip do Material só abre com toque longo;
// aqui ele abre com um toque simples e fecha ao tocar fora. O toque não chega ao elemento pai
// (não recolhe o card nem abre o select do campo). A classe `oa-info-tip` dá área de toque de 44 px.
@Directive({
    selector: "[matTooltip][appInfoTip]",
})
export class InfoTipDirective {
    @Input("matTooltip") message: string;

    @HostBinding("class.oa-info-tip") readonly infoTipClass = true;
    @HostBinding("attr.role") readonly role = "button";
    @HostBinding("attr.tabindex") readonly tabindex = 0;

    @HostBinding("attr.aria-label")
    get ariaLabel(): string {
        return this.message;
    }

    constructor(private tooltip: MatTooltip) {}

    @HostListener("click", ["$event"])
    onClick(event: Event): void {
        event.stopPropagation();
        event.preventDefault();
        // Abre depois que o clique termina: senão o próprio clique pode chegar ao detector de
        // "clique fora" do overlay e fechar a dica logo em seguida.
        setTimeout(() => this.tooltip.show());
    }

    @HostListener("keydown.enter", ["$event"])
    @HostListener("keydown.space", ["$event"])
    onKey(event: Event): void {
        event.stopPropagation();
        event.preventDefault();
        this.tooltip.toggle();
    }
}
